module.exports = __webpack_public_path__ + "fef7f34d91df541505a5672c8eca2cca.ttf";


//////////////////
// WEBPACK FOOTER
// ./fonts/museo_slab_500-webfont.ttf
// module id = poxC
// module chunks = 0